// Phần mềm khác (PMS) mở luồng xuất hóa đơn tùy chỉnh bằng URL /e-invoice?reservationIds=…&hotelId=…
// Đưa thẳng sang màn riêng, KHÔNG dựng màn danh sách (tránh nạp search-bar, danh sách, thống kê… không
// cần cho luồng này). Giữ /e-invoice làm điểm vào để không phải đổi URL phía phần mềm gọi sang.
const isCustomExportRedirect = (query) => !!(query && query.reservationIds && query.hotelId);

export default [
  {
    path: '/e-invoice',
    name: 'invoice-management',
    component: () =>
      import('@/views/modules/e-invoice/EInvoice.vue'),
    meta: {
      requiresAuth: true,
    },
    beforeEnter(to, from, next) {
      if (isCustomExportRedirect(to.query)) {
        next({ name: 'invoice-custom-export', query: to.query, replace: true });
        return;
      }
      next();
    },
  },
  {
    path: '/e-invoice/custom-export',
    name: 'invoice-custom-export',
    component: () =>
      import('@/views/modules/e-invoice/custom-export-e-invoice/CustomExportEInvoice.vue'),
    meta: {
      requiresAuth: true,
      // Chỉ có tác dụng nếu sau này bỏ hideVerticalMenu (hoặc dùng layout ngang): khi menu trái bị ẩn thì
      // không có link nào để sáng.
      navActiveLink: 'invoice-management',
      // Ẩn menu trái: màn này là một tác vụ toàn màn hình mở từ phần mềm khác, cần hết chiều ngang cho
      // cột module + bảng dịch vụ. Rời màn là menu hiện lại.
      hideVerticalMenu: true,
    },
  },
]
